import { useEffect, useRef } from 'react';

import { useAppSelector } from '@/Application/Hooks/Redux';
import { selectBuyNowCartData } from '@/Application/Selectors/buyNow/useBuyNowCart';
import { sendEcommerceEventsForFC } from '@/modules/shared/utils/gtmEvents/events/utilsFC';
import { useRegionAndCommune } from '@/sections/region/hooks/useRegionAndCommune';

export const useSendBuyNowEcommerceEvents = () => {
  const cart = useAppSelector(selectBuyNowCartData);
  const eventSent = useRef<Record<string, boolean>>({});

  const shippingAddress = cart?.shippingAddress || {};
  const regionAndCommune = useRegionAndCommune(shippingAddress);

  useEffect(() => {
    if (!cart) return;

    const hasLineItems = Boolean(cart?.lineItems && cart.lineItems.length > 0);
    if (!hasLineItems) return;

    const deliveryGroups = cart?.deliveryInfo?.deliveryGroups;
    if (!deliveryGroups) return;

    const hasDeliveryGroups = deliveryGroups.length > 0;
    if (!hasDeliveryGroups) return;

    if (!eventSent.current['ecommerce-events']) {
      sendEcommerceEventsForFC(cart, regionAndCommune);
      eventSent.current['ecommerce-events'] = true;
    }
  }, [cart, cart?.deliveryInfo, regionAndCommune]);
};
